import { createContext } from 'react';

const SlidesContext = createContext({});
SlidesContext.displayName = 'SlidesContext()';

export const SlidesContextProvider = SlidesContext.Provider;
export default SlidesContext;
